import { inject, Injectable, signal } from '@angular/core';
import { HxCallcenterService } from 'hx-services';

/** The menu is folded to the rail of icons — kept on this computer (the canvas: «Выбор помнится»). */
export const FOLDED_KEY = 'cc.shell.folded';

/**
 * The state of the new shell its parts share: the window of the operator number (opened from the header, the shift card, its menu), the folded menu and, in a narrow window, the menu as a drawer.
 */
@Injectable({ providedIn: 'root' })
export class ShellUiService {
  readonly numberDialog = signal(false);
  readonly folded = signal(readFolded());
  readonly drawer = signal(false);
  /** The numbers of the operator's groups are being read — the header shows «Загружаем…» on the place of the number, as the old one did. */
  readonly idsLoading = signal(true);

  private readonly callcenter = inject(HxCallcenterService);
  private ids?: Promise<number[]>;

  /** The numbers of the operator's groups, asked once and shared by the header and the window; a failure is asked again next time. */
  operatorIds(): Promise<number[]> {
    if (!this.ids) {
      this.idsLoading.set(true);
      this.ids = this.callcenter.getOperatorIds().then(ids => ids ?? []);
      this.ids.then(() => this.idsLoading.set(false), () => {
        this.ids = undefined;
        this.idsLoading.set(false);
      });
    }
    return this.ids;
  }

  openNumberDialog(): void {
    this.drawer.set(false);
    this.numberDialog.set(true);
  }

  closeNumberDialog(): void {
    this.numberDialog.set(false);
  }

  toggleFolded(): void {
    const folded = !this.folded();
    this.folded.set(folded);
    try {
      localStorage.setItem(FOLDED_KEY, folded ? '1' : '0');
    } catch {
      // without localStorage the menu unfolds again after a reload
    }
  }

  unfold(): void {
    if (this.folded()) {
      this.toggleFolded();
    }
  }

  openDrawer(): void {
    this.drawer.set(true);
  }

  closeDrawer(): void {
    this.drawer.set(false);
  }
}

function readFolded(): boolean {
  try {
    const own = localStorage.getItem(FOLDED_KEY);
    // never chosen in the new menu: the choice of the old one counts
    return own === null ? localStorage.getItem('sidebar') === 'minimize' : own === '1';
  } catch {
    return false;
  }
}
